import { render } from "./GanttChart.vue?vue&type=template&id=16daa6ae"
import script from "./GanttChart.vue?vue&type=script&lang=ts"
export * from "./GanttChart.vue?vue&type=script&lang=ts"
script.render = render

export default script